import api from './http';

export const SettingsAPI = {
  workflow: () => api.get('/settings/workflow').then((response) => response.data),
  saveWorkflow: (payload) => api.put('/settings/workflow', payload).then((response) => response.data),
};
